/*eslint no-script-url: 0 */
import React, { Component } from 'react';
import {Loader} from './Helpers/Helpers';
import FramePopUp from './Components/Modal/FramePopUp';
import FrameArea from './Components/FrameArea/FrameArea';

export default class LeftSideBar extends Component {

	constructor(props) {
        super(props);
        this.state = {
			lgShow: false,
			show: false
        }
        this.handleShow = this.handleShow.bind(this);
    	this.handleClose = this.handleClose.bind(this);
    	this.lgClose = this.lgClose.bind(this);
    	this.lgShowF = this.lgShowF.bind(this);
    }

	handleClose() {
		this.setState({ show: false });
	}

	handleShow() {
		this.setState({ show: true });
	}

	lgClose = () => this.setState({ lgShow: false });
	lgShowF = () => this.setState({ lgShow: true });

	render() {
		const {frameLoading, selectedFrame, rightFrameHeight} = this.props;

		if (frameLoading) {
			return(
				<div className="col-sm-7">
					<div className="img_set_sec" style={{height: rightFrameHeight}}>
						<Loader />
					</div>
				</div>
			);
		} else {
		    return (
		    	<div className="col-sm-7">
	    			<FrameArea
						{...this.props}
						lgShow={this.state.lgShow}
						lgShowF={this.lgShowF}
						lgClose={this.lgClose}
					/>
					{selectedFrame.size > 0 ?
						<div className="sel_img">
							<p>
								<a href="#!" className="right" onClick={this.handleShow}>View Frame Details <i><img src={selectedFrame.getIn(['images', 0, 'src'])} alt={selectedFrame.get('name')} /></i></a>
							</p>
							<FramePopUp {...this.props} show={this.state.show} onHide={this.handleClose} />
						</div>
						:
						''
					}
				</div>
		    );
		}
	}
}